import { render, staticRenderFns } from "./otcList.vue?vue&type=template&id=0802630b&"
import script from "./otcList.vue?vue&type=script&lang=js&"
export * from "./otcList.vue?vue&type=script&lang=js&"
import style0 from "./otcList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports